export default __webpack_public_path__ + "i18n/translations/translation-sv.39125a81.json";